module.exports = __webpack_public_path__ + "img/IMG_6164.e6b8516f.jpg";